import BaseHomeSectionListRouteStore from "./BaseHomeSectionListRouteStore";

class NakiMobileHomeSectionListRouteStore extends BaseHomeSectionListRouteStore {
    constructor(rootStore) {
        super(rootStore);
    }
}

export default NakiMobileHomeSectionListRouteStore;
